import DadosComplementares from './dadosComplementares';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  changeDadosComplementaresValueForm,
  handleChangeDadosGenero,
  handleChangeDadosEstadoCivil,
  handleChangeDadosFlagDomicilioFiscal,
  handleChangeDadosFlagPessoaAmericana,
  handleChangeTypeahead,
  getListDadosComplementaresEstadoCivilAction,
  getListDadosComplementaresGeneroAction,
  getListDadosComplementaresPaisAction
} from '../../store/dadosComplementares/actions';

import { handleChangePessoaAmericana } from '../../store/declaracaoEspecifica/actions';

const mapStateToProps = (state, nextState) => ({
  dadosComplementares: state.dadosComplementaresReducer,
  ddiReducer: state.ddiReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeDadosComplementaresValueForm,
    handleChangeDadosGenero,
    handleChangeDadosEstadoCivil,
    handleChangeDadosFlagDomicilioFiscal,
    handleChangeDadosFlagPessoaAmericana,
    handleChangeTypeahead,
    getListDadosComplementaresEstadoCivilAction,
    getListDadosComplementaresGeneroAction,
    getListDadosComplementaresPaisAction,
    handleChangePessoaAmericana
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DadosComplementares);